module.exports = {
    devServer: {
        proxy: {
            '/scop3ptm/api': {
                target: 'http://127.0.0.1:8088',
                ws: true,
                changeOrigin: true
            }
        }
    },
    publicPath: '/scop3ptm/',
    outputDir: 'target/dist',
    assetsDir: 'static',
    indexPath: 'index.html'
    // publicPath: process.env.NODE_ENV === 'production' ? '/scop3ptm/' : '/'
};
